// Whether a participant video should be on Cloudflare Stream and is not:
// accepted, with a source file, and no Cloudflare uid. A copy that failed
// (`cf.status === 'error'`) counts only with `includeErrors` — the
// event-wide backfill skips those unless asked.
//
// Mirrors `functions/lib/streamCopy.js`, which decides what the backfill
// actually sends. The functions package is not importable from the browser
// bundle; change one, change the other.

/**
 * @param {?Object} data A `videos` document.
 * @param {{includeErrors?: boolean}} [opts]
 * @returns {boolean}
 */
export function needsStreamCopy(data, { includeErrors = false } = {}) {
  if (!data || data.accepted !== true || !data.videoUrl) return false
  const cf = data.cf
  if (!cf) return true
  if (cf.uid) return false
  return includeErrors || cf.status !== 'error'
}

/** True when a video/reel document has a playable Cloudflare copy. */
export function isStreamReady(doc) {
  return doc?.cf?.status === 'ready' && !!doc?.cf?.uid
}
